import React, { createContext, useContext, useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { storage } from 'src/common/localStorage';
import api from 'src/config/api';

const MainLayoutContext = createContext();

export const MainLayoutProvider = ({ children, sidebarConfig }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [breadcrumb, setBreadcrumb] = useState([]);
    const navigate = useNavigate()
    const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };
    
    const logout = async () => {
      try {
        // Send logout request to server
        await api.post('auth/logout', {
          refreshToken: storage.getItem('refreshToken')
        });
      } catch (error) {
        console.error('Logout error:', error);
      } finally {
        storage.clearAuthData();
        delete api.defaults.headers.common['Authorization'];
        navigate("/", { replace: true });
      }
    };

    const contextValue = {
        collapsed,
        toggleSidebar,
        sidebarConfig,
        logout,
        breadcrumb,
        setBreadcrumb
    };

    return (
        <MainLayoutContext.Provider value={contextValue}>
            {children}
        </MainLayoutContext.Provider>
    );
};

export const useMainLayout = () => {
    return useContext(MainLayoutContext);
}; 